<script lang="ts">
</script>

<svg
  width="44"
  height="40"
  viewBox="0 0 44 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="size-12"
>
  <path
    d="M10.4069 0L0 27.5334L16.3227 34.1647L27.7467 6.80291L10.4069 0Z"
    fill="white"
  />
  <path
    d="M11.3788 2.92969L25.3745 8.61455L15.8358 32.0948L1.76562 26.5929L11.3788 2.92969Z"
    fill="#0D0D0D"
  />
  <path
    d="M11.3283 6.30469L22.8696 10.9927L16.1462 28.0712L4.42188 23.3075L11.3283 6.30469Z"
    fill="white"
  />
  <path
    d="M14.7307 5.57812L14.4531 6.59143L20.2642 8.79093L20.5544 8.07795L14.7307 5.57812Z"
    fill="white"
  />
  <path
    d="M8.53187 26.3438L11.0405 27.3634L10.6796 28.383L8.10156 27.4037L8.53187 26.3438Z"
    fill="white"
  />
  <path
    d="M32.4384 39.6191L19.0786 33.8396L19.4206 28.3882L20.8062 28.098L16.729 21.9411L14.3957 23.8403L11.0391 20.9707L17.1164 11.9961L19.2402 18.452L20.4844 16.7724L23.8612 20.6906L33.8012 17.5775L43.34 31.9001L32.4384 39.6191Z"
    fill="white"
  />
  <path
    d="M17.3637 18.3736L14.3906 14.5185L16.7706 13.3828L17.3637 18.3736Z"
    fill="#0D0D0D"
  />
  <path
    d="M16.0603 19.8705L12.4235 17.9297L12.3125 19.8415L16.0603 19.8705Z"
    fill="#0D0D0D"
  />
  <path
    d="M19.1495 16.7483L20.2701 14.3116L18.9375 13.7109L19.1495 16.7483Z"
    fill="#0D0D0D"
  />
  <path
    d="M15.5086 20.9648L13.2422 21.6286L14.0788 22.7403L15.5086 20.9648Z"
    fill="#0D0D0D"
  />
  <path
    d="M32.5226 38.2549L20.2872 32.9751L20.797 29.9819L25.2452 31.2754L17.3672 21.1133L18.4941 19.9675L19.9516 19.1094L24.8705 25.0529L24.2294 23.1929L26.5765 21.6105L27.4321 22.6553L27.1583 21.2925L29.8247 19.9271L30.6285 20.8596L30.6373 19.8223L32.6274 19.1573L40.4713 32.0918L32.5226 38.2549Z"
    fill="#0D0D0D"
  />
</svg>
